import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { AttachmentInsertService } from "../../service/attachment-insert/attachment-insert.service";
import { LayoutProposta } from '../../../models/layout-proposta';
import { DocumentType } from '../../../models/document-type';
import { CustomValidators } from '../../../validator/custom-validator';


@Component({
	selector: 'app-attachment-insert',
	templateUrl: './attachment-insert.component.html',
	providers: [
		AttachmentInsertService,
		HttpModule
	]
})
export class AttachmentInsertComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	public layoutProposta: LayoutProposta;
	public documentTypes: DocumentType;
	attachment: FormGroup;
	ID: string;
	Descricao: string = '';
	DescricaoAbreviado: string = '';
	Obrigatorio: boolean;
	Formulario: number;
	DescricaoFormulario: string = '';
	Ativo: boolean;

	constructor(private fb: FormBuilder, private attachmentInsertService: AttachmentInsertService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.layoutProposta = new LayoutProposta();
		this.documentTypes = new DocumentType();
		this.attachment = fb.group({
			'Descricao': ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
			'Obrigatorio': '',
			'LayoutsProposta': this.fb.array(
				this.layoutProposta.getArray().map(() => this.fb.control('')),
				
			),
			'CategoriaDocumento' : [0,Validators.compose([Validators.min(1)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}




	insertAttachment(value: any) {

		var layouts = [];

		for (let i = 0; i < value.LayoutsProposta.length; i++) {
				if (value.LayoutsProposta[i] == true) {
					layouts.push(i+1);
				}
		}

		var obj = {

			Ativo: value.Ativo,
			CategoriaDocumento: value.CategoriaDocumento,
			Descricao: value.Descricao,
			LayoutsProposta: layouts.join(','),
			Obrigatorio: value.Obrigatorio

		}

		this.attachmentInsertService.insertAttachment(this.token, obj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Anexo inserido com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/anexo');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}

	cancelInsert() {
		this.router.navigateByUrl('/anexo');
	}

}



// WEBPACK FOOTER //
// ./src/app/attachment/component/attachment-insert/attachment-insert.component.ts